var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbleLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.10378 25.4973H1.18692C0.528721 25.4973 0 26.026 0 26.6842V29.1876C0 29.8458 0.528721 30.3745 1.18692 30.3745H5.10378C5.76198 30.3745 6.2907 29.8458 6.2907 29.1876V26.6842C6.2907 26.026 5.76198 25.4973 5.10378 25.4973Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3246 18.0305H6.31223C6.32302 17.9657 6.3446 17.901 6.36618 17.8255L12.3871 1.60776C12.6785 0.830861 12.1066 0.0108032 11.2757 0.0108032H7.52074C7.02439 0.0108032 6.58199 0.32372 6.40935 0.7877L0.0862734 17.8363C0.0323223 17.9657 0.0107422 18.106 0.0107422 18.2463V19.2174V23.1343C0.0107422 23.7925 0.539463 24.3212 1.19767 24.3212H5.11452H25.3354C25.9936 24.3212 26.5223 23.7925 26.5223 23.1343V19.2174C26.5115 18.5592 25.9828 18.0305 25.3246 18.0305Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8964 18.0305H32.8132C33.4715 18.0305 34.0002 18.5592 34.0002 19.2174V29.1876C34.0002 29.8458 33.4715 30.3745 32.8132 30.3745H28.8964C28.2382 30.3745 27.7095 29.8458 27.7095 29.1876V19.2066C27.7095 18.5592 28.2382 18.0305 28.8964 18.0305Z",
    fill: "#00C6C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9855 15.1927C31.4101 10.9089 27.5903 0.776927 27.5903 0.776927C27.4177 0.312947 26.9753 3.05176e-05 26.4789 3.05176e-05H26.4682H22.7239H15.0845C14.5881 3.05176e-05 14.1457 0.312947 13.9731 0.776927L12.5164 4.69378C12.2251 5.47068 12.7969 6.29073 13.6278 6.29073H23.3714C24.8172 10.1536 26.3063 14.0705 27.0077 16.0127C27.1803 16.4875 27.6335 16.8004 28.1298 16.8004H31.8633C32.6941 16.8004 33.2768 15.9696 32.9855 15.1927Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbleLogoDark);
export default __webpack_public_path__ + "static/media/able-logo-dark.af5faa7b7c676e87176282144894f9d6.svg";
export { ForwardRef as ReactComponent };